import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, EMPTY, map, Observable, switchMap } from 'rxjs';

import { AlertPanelViewModel } from './components/alert-panel/alert-panel.component';
import {
  NotificationGroup,
  NotificationPreferences,
  NotificationPreferencesStateService,
  NotificationType,
} from '@usf/ngrx-alerts';
import { Router } from '@angular/router';
import { PATHS } from '../../../../shared/constants/paths';
import { ViewDidLeave } from '@ionic/angular';
import { ViewWillEnter } from '@ionic/angular';

interface PreferencesPageViewModel {
  emailAddress: any;
  phoneNumber: number;
  hasActiveEmailNotifications: boolean;
  hasActivePushNotifications: boolean;
  alertPanelViewModels: AlertPanelViewModel[];
}

@Component({
  selector: 'app-notification-preferences-dashboard',
  templateUrl: './notification-preferences-dashboard.page.html',
  styleUrls: ['./notification-preferences-dashboard.page.scss'],
  standalone: false,
})
export class NotificationPreferencesDashboardPage
  implements OnInit, ViewWillEnter, ViewDidLeave
{
  public preferencesPageViewModel$: Observable<PreferencesPageViewModel> =
    EMPTY;
  private readonly pageInViewSubject: BehaviorSubject<boolean> =
    new BehaviorSubject(false);

  private readonly newProperty = map(
    (
      notificationPreferences: NotificationPreferences,
    ): PreferencesPageViewModel => ({
      emailAddress: notificationPreferences.emailAddress,
      phoneNumber: 212,
      hasActiveEmailNotifications: notificationPreferences.emailActive,
      hasActivePushNotifications: notificationPreferences.pushActive,
      alertPanelViewModels:
        notificationPreferences.types.map<AlertPanelViewModel>(
          (notificaionType: NotificationType) => {
            return {
              alertType: notificaionType.type,
              alertEnabled: notificaionType.groups.some(
                (group: NotificationGroup) => group.isEnabled,
              ),
              subscribedCount: notificaionType.groups.filter(
                (group: NotificationGroup) => group.isEnabled,
              ).length,
              totalCount: notificaionType.groups.length,
              disabled: false,
            };
          },
        ),
    }),
  );

  constructor(
    private readonly router: Router,
    private readonly notificationPreferencesStateService: NotificationPreferencesStateService,
  ) {
    this.notificationPreferencesStateService.loadNotificationPreferences();
  }

  ngOnInit(): void {
    this.pageInViewSubject.next(true);
    this.preferencesPageViewModel$ = this.pageInViewSubject.pipe(
      switchMap(inView => {
        if (!inView) {
          return EMPTY;
        } else {
          return this.notificationPreferencesStateService
            .selectNotificationPreferences$()
            .pipe(this.newProperty);
        }
      }),
    );
  }

  onAlertPanelClick(alertType: string) {
    this.router.navigate(
      ['notifications', PATHS.NOTIFICATION_PREFERENCES, 'type-overview'],
      { queryParams: { typeId: alertType } },
    );
  }

  ionViewWillEnter() {
    this.pageInViewSubject.next(true);
  }

  ionViewDidLeave() {
    this.pageInViewSubject.next(false);
  }
}
